import { LensPackage } from '../meta/IBrain';
import { getCookieByName } from '../utils/functions';

export function useEnableRemoveLenses() {
  const enableRemoveLensesCookie = getCookieByName('rxc_remove_lenses');

  if (!enableRemoveLensesCookie) return null;

  function parseCondition(
    condition: string
  ): (item: LensPackage['lensPackage']) => boolean {
    // Prima sostituisci AND/OR con operatori JS
    const jsExpression = condition
      .replace(/\bAND\b/g, '&&')
      .replace(/\bOR\b/g, '||')
      .replace(
        /([a-zA-Z0-9_]+)\s*==\s*(.+?)(?=\s*(?:AND|OR|\)|$))/g,
        (_, key, rawValue) => {
          const trimmed = rawValue.trim();

          let value: string;
          if (trimmed === `''`) {
            value = '""';
          } else if (trimmed === 'null') {
            value = 'null';
          } else {
            value = `"${trimmed}"`;
          }

          return `item["${key}"] === ${value}`;
        }
      );

    return new Function('item', `return ${jsExpression};`) as (
      item: LensPackage['lensPackage']
    ) => boolean;
  }

  const filterFn = parseCondition(enableRemoveLensesCookie as string);
  return filterFn;
}
